export const state = () => ({
  url: '/api/sm/admin/general',
  applyUrl: '/api/sm/managers/general'
})

export const actions = {
  // SYSTEM > 관리자 설정 > 공통 설정 > 조회
  async getAdminGeneral ({commit, state}) {
    let res = { code: 'ok', result: {} }
    try {
      res = await this.$axios.$get(`${state.url}`, {successAlert: false})
    } catch (error) {
      res.code = 'nok'
      res.result.msg = error.message
    }
    return res
  },
  // SYSTEM > 관리자 설정 > 공통 설정 > 설정
  async setAdminGeneral ({commit, state}, payload) {
    let res = { code: 'ok', result: {} }
    try {
      res = await this.$axios.$put(`${state.url}`, {list: payload}, {loading: false, successAlert: false})
    } catch (error) {
      res.code = 'nok'
      res.result.msg = error.message
    }
    return res
  },
  // SYSTEM > 관리자 설정 > 공통 설정 > APPLY & CANCEL
  async commitAndRollBackPage ({commit, state}, type) {
    let res = { code: 'ok', result: {} }
    try {
      let config = {}
      if (type === 'apply') {
        config = {applyMsg: true, loading: false}
      } else if (type === 'cancel') {
        config = {cancelMsg: true, loading: false}
      }
      res = await this.$axios.$put(`${state.applyUrl}/${type}`, void 0, config)
    } catch (error) {
      res.code = 'nok'
      res.result.msg = error.message
    }
    return res
  }
}
export const getters = {}
export const strict = false
